export default __webpack_public_path__ + "static/media/arrow-right-white.c2adb296.svg";